import { Layout, } from 'antd';

import MenuList from './MenuList';
const { Header } = Layout;

const NavBarTransparent = ({
    k,
    active,
    setactive,
    bgBlackTransparent
}) => {
    return (
        < Layout >
            <Header
                id='header'
                style={{
                    position: 'relative',
                    zIndex: 1,
                    width: '100%',
                    height: "84px",
                    background: bgBlackTransparent && "black"
                }}
                className="static">
                <MenuList
                    active={active}
                    setactive={setactive}
                    k={k} />
            </Header>
        </ Layout >
    )
}

export default NavBarTransparent;